import { CalendarModule } from 'primeng/calendar';
import { HisSharedModule } from 'hisng';
import { FileUploadModule } from 'primeng/fileupload';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputNumberModule } from 'primeng/inputnumber';
import { PanelModule } from 'primeng/panel';
import { BusinesstripApplicationTraveldataComponent } from './businesstripapplication-traveldata.component';
import { BusinesstripApplicationOverviewTraveldataComponent } from './overview/businesstripapplication-overview-traveldata.component';
import { BusinesstripApplicationTravelItineraryComponent } from './businesstripapplication-travel-itinerary.component';
import { DialogModule } from 'primeng/dialog';
import { BusinesstripApplicationAssetsComponent } from './businesstripapplication-assets.component';
import { BusinesstripApplicationTransportationComponent } from './businesstripapplication-transportation.component';
import { BusinesstripApplicationBahncardComponent } from './businesstripapplication-bahncard.component';
import { BusinesstripApplicationEstimatedCostsComponent } from './businesstripapplication-estimated-costs.component';
import { BusinesstripApplicationDocumentsComponent } from './businesstripapplication-documents.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TableModule } from 'primeng/table';
import { BusinesstripApplicationTravelAbroadComponent } from './businesstripapplication-travel-abroad.component';
import { BusinesstripApplicationA1BescheinigungComponent } from './businesstripapplication-a1-bescheinigung.component';
import { BusinesstripApplicationFinancingComponent } from './businesstripapplication-financing.component';
import { BusinesstripApplicationReimbursementCostsComponent } from './businesstripapplication-reimbursement-costs.component';
import { BusinesstripApplicationFurtherDetailsComponent } from './businesstripapplication-further-details.component';
import { BusinesstripApplicationBankdetailsComponent } from './businesstripapplication-bankdetails.component';

@NgModule( {
    imports: [
        // Angular
        CommonModule,
        PanelModule,
        FormsModule,
        HttpClientModule,

        // PrimeNG
        AutoCompleteModule,
        InputNumberModule,
        CalendarModule,
        FileUploadModule,
        OverlayPanelModule,
        TableModule,

        // HIS
        HisSharedModule,
        DialogModule,

    ],
    declarations: [
        BusinesstripApplicationAssetsComponent,
        BusinesstripApplicationFinancingComponent,
        BusinesstripApplicationTraveldataComponent,
        BusinesstripApplicationOverviewTraveldataComponent,
        BusinesstripApplicationTravelItineraryComponent,
        BusinesstripApplicationTransportationComponent,
        BusinesstripApplicationBahncardComponent,
        BusinesstripApplicationDocumentsComponent,
        BusinesstripApplicationEstimatedCostsComponent,
        BusinesstripApplicationTravelAbroadComponent,
        BusinesstripApplicationA1BescheinigungComponent,
        BusinesstripApplicationReimbursementCostsComponent,
        BusinesstripApplicationFurtherDetailsComponent,
        BusinesstripApplicationBankdetailsComponent,
    ],
    exports: [
        BusinesstripApplicationAssetsComponent,
        BusinesstripApplicationFinancingComponent,
        BusinesstripApplicationTraveldataComponent,
        BusinesstripApplicationOverviewTraveldataComponent,
        BusinesstripApplicationTravelItineraryComponent,
        BusinesstripApplicationTransportationComponent,
        BusinesstripApplicationBahncardComponent,
        BusinesstripApplicationDocumentsComponent,
        BusinesstripApplicationEstimatedCostsComponent,
        BusinesstripApplicationA1BescheinigungComponent,
        BusinesstripApplicationTravelAbroadComponent,
        BusinesstripApplicationReimbursementCostsComponent,
        BusinesstripApplicationFurtherDetailsComponent,
        BusinesstripApplicationBankdetailsComponent,
    ],
} )
export class BusinesstripApplicationViewsSharedModule {

}
